<template>
  <div
    v-if="hasPendingConfiguration || isDraft"
    :class="[
      'info-box',
      isDraft && hasPendingConfiguration && 'info-box--type-warning',
      isDraft && !hasPendingConfiguration && 'info-box--type-info',
      !isDraft && hasPendingConfiguration && 'info-box--type-warning'
    ]"
  >
    <v-icon>vizartist_show_scene_info_editor</v-icon>

    <span>{{ warningMessage }}</span>
  </div>
</template>

<script lang="ts">
import { defineComponent, computed, PropType } from "@vue/composition-api"
import { useStore } from "@/composable/useStore"
import { IWorkspaceAsset, Service, WorkspaceStatusEnum } from "@/types/workspace"
import { createTranslationModule } from "@/plugins/i18n"
import { useWizard } from "@/composable/useWizard"
import { WizardConfigItem } from "@/types/wizard"
import { useServices } from "../../composable/useServices"
import "../../scss/_serviceWarning.scss"

export default defineComponent({
  name: "ServiceWarning",
  props: {
    app: {
      type: Object as PropType<IWorkspaceAsset | Service>,
      required: true
    }
  },
  setup(props) {
    const { spaceModule } = useStore()
    const { newServices } = useServices()
    const t = createTranslationModule("WorkspaceEdit.appCard.service")

    const wizard = computed(() => {
      return props.app.userConfigurations as WizardConfigItem[]
    })

    const isValid = computed(() => {
      if (wizard.value) {
        const { validate } = useWizard(wizard)

        return wizard.value.every(item => {
          return validate(item.resourceKey)
        })
      }

      return true
    })

    const warningMessage = computed(() => {
      if (hasPendingConfiguration.value) {
        return t("validationError")
      } else if (isDraft.value) {
        return t("preDeployWarning")
      }
    })

    const service = computed(() => {
      return props.app as Service
    })

    const isDraft = computed(() => {
      const space = spaceModule.watching

      const isNew = newServices.value.some(newService => {
        return newService.id === service.value.id
      })

      if (space && space.status === WorkspaceStatusEnum.Draft) {
        return true
      }

      return isNew
    })

    const hasPendingConfiguration = computed(() => {
      return !isValid.value
    })

    return {
      t,
      warningMessage,
      isDraft,
      hasPendingConfiguration,
      service
    }
  }
})
</script>
